import * as React from "react";
import { Provider } from "mobx-react";
import { Router, Route, IndexRoute, hashHistory as History } from "react-router";
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import routeList from "./routes";
import * as injectTapEventPlugin from "react-tap-event-plugin";
import SeekerStore from "../../stores/seekerStore";
import Snackbar from "../../components/widgets/snackbar";
import App from "../app";
import Landing from "../landing";
import * as ReactGA from "react-ga";
import Fetcher from "../../utils/fetcher";

const store = new SeekerStore();

injectTapEventPlugin();


const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#FFF",
      contrastText: "#5B6770",
    },
    secondary: {
      main: "#0072CE",
      contrastText: "#FFF",
    },
    text: {
      primary: "#5B6770",
      secondary: "#5B6770", 
      hint: "#e57373",
    },
    action: {
      active: "#fff",
    }
  },
  typography: {
    fontFamily: "Roboto",
  },
});

export default class AppBody extends React.Component<{}, {}> {
  tracked: boolean = false;
  constructor(props:any) {
    super(props);
    Fetcher.get("api/lookups/gacode/seeker", (code: string): void => {
      if (code) {
        ReactGA.initialize(code);
        this.tracked = true;
      }
    });
  }
  track = (): void => {
    if (this.tracked) {
      ReactGA.pageview(window.location.hash);
    }
  }
  render(): JSX.Element {
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <Router onUpdate={this.track} history={History}>
            <Route path="/" component={App}>
              <IndexRoute component={Landing} />
              {routeList}
            </Route>
          </Router>
        </Provider>
<Snackbar store={store} />
      </MuiThemeProvider>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/appBody/index.tsx